export default __webpack_public_path__ + "static/media/CA.c3c4cde3.svg";